import writtenNumber from 'written-number'

const DECIMAL_CONNECTORS = {
  en: ' and ',
  fr: ' et ',
  ar: ' و'
}

const SUPPORTED_LANGUAGES = Object.keys(DECIMAL_CONNECTORS)

export const amountInWords = (amount, currency, requestedLanguage = 'en') => {
  const lang = SUPPORTED_LANGUAGES.includes(requestedLanguage) ? requestedLanguage : 'en'
  const normalizedAmount = typeof amount === 'string'
    ? amount.trim().replace(',', '.')
    : amount
  const numericAmount = Number(normalizedAmount)

  // Keep the previous behavior for values the written-number package cannot convert.
  if (!Number.isFinite(numericAmount) || numericAmount < 0) {
    return `${writtenNumber(amount, { lang })} ${currency}`.trim()
  }

  // Invoice amounts are displayed with two decimal places. Converting to minor
  // units also prevents floating-point totals such as 0.1 + 0.2 leaking through.
  const amountInMinorUnits = Math.round((numericAmount + Number.EPSILON) * 100)
  const integerPart = Math.floor(amountInMinorUnits / 100)
  const decimalPart = amountInMinorUnits % 100

  let result = writtenNumber(integerPart, { lang })
  if (decimalPart > 0) {
    result += `${DECIMAL_CONNECTORS[lang]}${writtenNumber(decimalPart, { lang })}`
  }

  return `${result} ${currency}`.trim()
}
